import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Vote, FileText } from "lucide-react";
import api from "@/lib/api";
import { resolveContentHtml } from "@/lib/url";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function VotingGuidePage() {
    const [data, setData] = useState({ voting_guide_title: "", voting_guide_content: "" });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = "Jak głosować – Dąbrówka Wiślana";
        api.get("/settings")
            .then((r) => setData(r.data || {}))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="voting-guide-page" className="min-h-screen bg-[#FDFDFD]">
            <Navbar />

            <header className="bg-[#092E22] text-white pt-32 pb-16 relative overflow-hidden">
                <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-[#D4A537]/15 blur-3xl" />
                <div className="max-w-4xl mx-auto px-6 lg:px-10 relative z-10">
                    <Link to="/#uchwaly" data-testid="voting-back-link" className="inline-flex items-center gap-2 text-[#D4A537] text-sm hover:underline">
                        <ArrowLeft size={14} /> Powrót do uchwał
                    </Link>
                    <div className="flex items-center gap-4 mt-6 mb-4">
                        <div className="w-14 h-14 rounded-2xl bg-[#D4A537]/20 flex items-center justify-center">
                            <Vote className="text-[#D4A537]" size={26} />
                        </div>
                        <p className="text-[#D4A537] uppercase tracking-[0.25em] text-xs font-semibold">Instrukcja</p>
                    </div>
                    <h1 className="font-serif text-4xl md:text-5xl leading-tight">
                        {loading ? "Wczytywanie..." : (data.voting_guide_title || "Jak głosować")}
                    </h1>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16 md:py-20">
                <motion.article
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12"
                    data-testid="voting-guide-content"
                >
                    <div className="flex items-center gap-2 text-[#0D4F3C] mb-6">
                        <FileText size={18} />
                        <span className="text-sm font-medium uppercase tracking-wider">Treść instrukcji</span>
                    </div>
                    <div className="divider-gold w-24 mb-8" />
                    <div className="prose prose-lg max-w-none">
                        {loading ? (
                            <p className="text-gray-500">Wczytywanie...</p>
                        ) : (
                            <div
                                className="text-gray-700 leading-relaxed text-base md:text-lg rich-content"
                                dangerouslySetInnerHTML={{ __html: resolveContentHtml(data.voting_guide_content) || "Treść instrukcji zostanie wkrótce uzupełniona przez administratora strony." }}
                            />
                        )}
                    </div>
                </motion.article>

                <div className="mt-10 text-center">
                    <Link
                        to="/#uchwaly"
                        data-testid="voting-back-to-resolutions"
                        className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white font-medium transition-all hover:-translate-y-0.5"
                    >
                        <ArrowLeft size={16} /> Wróć do listy uchwał
                    </Link>
                </div>
            </main>

            <Footer />
        </div>
    );
}
